var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHaulage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.548828,
    y: 0.220703,
    width: 44,
    height: 44,
    rx: 10,
    fill: "#FCDFD3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_1318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5488 18.2207H30.5488L33.5488 22.2767V28.2207H31.5138C31.3949 29.055 30.979 29.8184 30.3425 30.3706C29.706 30.9229 28.8915 31.227 28.0488 31.227C27.2061 31.227 26.3917 30.9229 25.7551 30.3706C25.1186 29.8184 24.7027 29.055 24.5838 28.2207H19.5138C19.3949 29.055 18.979 29.8184 18.3425 30.3706C17.706 30.9229 16.8915 31.227 16.0488 31.227C15.2061 31.227 14.3917 30.9229 13.7551 30.3706C13.1186 29.8184 12.7027 29.055 12.5838 28.2207H11.5488V16.2207C11.5488 15.9555 11.6542 15.7011 11.8417 15.5136C12.0293 15.3261 12.2836 15.2207 12.5488 15.2207H26.5488C26.814 15.2207 27.0684 15.3261 27.2559 15.5136C27.4435 15.7011 27.5488 15.9555 27.5488 16.2207V18.2207ZM27.5488 20.2207V23.2207H31.5488V22.9357L29.5408 20.2207H27.5488Z",
    fill: "#782F11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_1318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10.5488 10.2207)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaulage);
export default __webpack_public_path__ + "static/media/Haulage.e20f32f44feb0ed45ba3920098aca43c.svg";
export { ForwardRef as ReactComponent };